import { Injectable } from "@angular/core";
import { Subject } from "rxjs/internal/Subject";
import { PanelLocationsService } from "../../../../map-features/sections/locations-section/services/Panel-Locations.service";
import { PanelDetailGeofencesService } from "../../../../map-features/sections/geofences-section/services/Panel-Detail-Geofences.service";
import { PanelDetailLocationsService } from "../../../../map-features/sections/locations-section/services/Panel-Detail-Locations.service";
import { PanelResumeRouteService } from "../../../../map-features/sections/route-section/services/Panel-Resume-Route.service";
import { RouteFilterService } from "../../../../map-features/sections/route-section/services/Route-Filter.service";
import { RouteMapService } from "src/app/features/map-features/sections/route-section/services/RouteMap.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { GeofencesService } from "../../../../map-features/sections/geofences-section/services/Geofences.service";
import { environment } from "src/environments/environment";
import { TerritoriesService } from "src/app/features/map-features/sections/territories-section/services/TerritoriesService.service";
import { FrecuencyZonesMapSectionService } from "src/app/features/map-features/sections/frecuency-zones-section/services/frecuencyZones-section.service";
import { PotentialZonesMapSectionService } from "src/app/features/map-features/sections/potential-zones-section/services/potentialZones-map-section.service";
import { ProspectsMapSectionService } from "src/app/features/map-features/sections/prospects-section/services/prospects-map-section.service";

@Injectable({
  providedIn: "root",
})
export class NavHeaderService {
  public pushedClassSelected: string;
  isLocationSelected: boolean;
  isRoutesSelected: boolean;
  isGeofencesSelected: boolean;
  isPotentialZonesSelected: boolean;
  isProspectsSelected: boolean;
  isFrecuencyZonesSelected: boolean;
  isTerritoriesSelected: boolean;

  selectedPanel: any;
  private isLocationSelected$: Subject<boolean> = new Subject();
  private isRoutesSelected$: Subject<boolean> = new Subject();
  private isGeofencesSelected$: Subject<boolean> = new Subject();
  private isPotentialZonesSelected$: Subject<boolean> = new Subject();
  private isProspectsSelected$: Subject<boolean> = new Subject();
  private isFrecuencyZonesSelected$: Subject<boolean> = new Subject();
  private pushedClassSelected$: Subject<string> = new Subject();
  private isTerritoriesSelected$: Subject<boolean> = new Subject();
  suscription_SelectedPanel: Subscription;

  constructor(
    private panelLocationsService: PanelLocationsService,
    private panelDetalilService: PanelDetailLocationsService,
    private routeMapFilterService: RouteFilterService,
    private panelResumeService: PanelResumeRouteService,
    private geofencesMapService: GeofencesService,
    private panelDetailGeofences: PanelDetailGeofencesService,
    private GeofencesServices: GeofencesService,
    private routeMapService: RouteMapService,
    private potentialZonesMapService: PotentialZonesMapSectionService,
    private prospectsMapService: ProspectsMapSectionService,
    private frecuencyZonesMapService: FrecuencyZonesMapSectionService,
    private territoriesMapService: TerritoriesService,
    private route: ActivatedRoute
  ) {}

  checkPanelsVisibility() {
    if(!environment.production) console.log("locations", this.isLocationSelected);
    if(!environment.production) console.log("routes", this.isRoutesSelected);
    if(!environment.production) console.log("geofences", this.isGeofencesSelected);
    if(!environment.production) console.log("potential zones", this.isPotentialZonesSelected);
    if(!environment.production) console.log("prospects", this.isProspectsSelected);
    if(!environment.production) console.log("frecuency zones", this.isFrecuencyZonesSelected);
    if(!environment.production) console.log("territories", this.isTerritoriesSelected);
    if (this.isLocationSelected) {
      //cierra detalle y abre locations
      this.panelLocationsService.setVisibilityPanel(true);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();


      //cierra Geofences
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Potential Zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    } else if (this.isRoutesSelected) {
      //cierra resumen de ruta y abre Routes
      this.routeMapFilterService.setVisibilityPanel(true);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();


      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Geofences
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Potential Zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    } else if (this.isGeofencesSelected) {
      //cierra todo lo relacionado con geocercas excepto Geofences
      this.geofencesMapService.setVisiblePanelGeofences(true);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();

      //cierra Potential Zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    }else if (this.isPotentialZonesSelected) {
      //abre potential zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(true);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra gocercas
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    }else if (this.isProspectsSelected) {
      this.prospectsMapService.setIsProspectsVisible(true);

      //cierra potential zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      //cierra gocercas
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    } else if (this.isFrecuencyZonesSelected) {
      //abre frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(true);

      //cierra potential zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra gocercas
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();

      //cierra territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

    }else if (this.isTerritoriesSelected) {
      //abre territories
      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(true);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

      //cierra potential zones
      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      //cierra gocercas
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();

      //cierra frecuency zones
      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);
    }
    else{
      //cierra todo
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      this.potentialZonesMapService.setIsPotentialZonesVisible(false);

      this.prospectsMapService.setIsProspectsVisible(false);

      this.frecuencyZonesMapService.setIsFrecuencyZonesVisible(false);

      this.territoriesMapService.setVisiblePanelDetailTerritories(false);
      this.territoriesMapService.setVisiblePanelTerritories(false);
      this.territoriesMapService.setVisiblePanelEditTerritories(false);

      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.deleteRoutesData();
    }
  }

  setIsLocationSelected(resp) {
    this.isLocationSelected = true;
    this.isRoutesSelected = false;
    this.isGeofencesSelected = false;
    this.isPotentialZonesSelected = false;
    this.isProspectsSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected = false;
    this.isLocationSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsRoutesSelected() {
    return this.isRoutesSelected$.asObservable();
  }

  getPushedClass() {
    return this.pushedClassSelected$.asObservable();
  }

  setPushedClass() {
    if (this.isLocationSelected) {
      this.pushedClassSelected = "locationsMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
    if (this.isRoutesSelected) {
      this.pushedClassSelected = "routingMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
    if (this.isGeofencesSelected) {
      this.pushedClassSelected = "geofencesMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
  }

  setIsRoutesSelected(resp) {
    this.isRoutesSelected = true;
    this.isLocationSelected = false;
    this.isGeofencesSelected = false;
    this.isPotentialZonesSelected = false;
    this.isProspectsSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected = false;
    this.isRoutesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsLocationSelected() {
    return this.isLocationSelected$.asObservable();
  }

  setIsGeofencesSelected(resp) {
    this.isGeofencesSelected = true;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isPotentialZonesSelected = false;
    this.isProspectsSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected = false;
    this.isGeofencesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsGeofencesSelected() {
    return this.isGeofencesSelected$.asObservable();
  }

  setIsPotentialZonesSelected(resp) {
    this.isPotentialZonesSelected = resp;
    this.isGeofencesSelected = false;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isProspectsSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected = false;
    this.isPotentialZonesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsPotentialZonesSelected() {
    return this.isPotentialZonesSelected$.asObservable();
  }

  setIsProspectsSelected(resp) {
    this.isProspectsSelected = resp;
    this.isGeofencesSelected = false;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isPotentialZonesSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected = false;
    this.isProspectsSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsProspectsSelected() {
    return this.isProspectsSelected$.asObservable();
  }

  setIsFrecuencyZonesSelected(resp) {
    this.isFrecuencyZonesSelected = resp;
    this.isGeofencesSelected = false;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isPotentialZonesSelected = false;
    this.isProspectsSelected = false;
    this.isTerritoriesSelected = false;
    this.isFrecuencyZonesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  setIsTerritoriesSelected(resp) {
    this.isTerritoriesSelected = resp;
    this.isGeofencesSelected = false;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isPotentialZonesSelected = false;
    this.isProspectsSelected = false;
    this.isFrecuencyZonesSelected = false;
    this.isTerritoriesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsFrecuencyZonesSelected() {
    return this.isFrecuencyZonesSelected$.asObservable();
  }

  closeAllPanels() {
    this.isLocationSelected = false;
    this.isLocationSelected$.next(false);
    this.isRoutesSelected = false;
    this.isRoutesSelected$.next(false);
    this.isGeofencesSelected = false;
    this.isGeofencesSelected$.next(false);
    this.isPotentialZonesSelected = false;
    this.isPotentialZonesSelected$.next(false);
    this.isProspectsSelected = false;
    this.isProspectsSelected$.next(false);
    this.isFrecuencyZonesSelected = false;
    this.isFrecuencyZonesSelected$.next(false);
    this.isTerritoriesSelected = false;
    this.isTerritoriesSelected$.next(false);
    this.checkPanelsVisibility();
  }

  CheckMapPaneles(openOnDefault?: string){
    if (this.suscription_SelectedPanel) this.suscription_SelectedPanel.unsubscribe();
    
    this.suscription_SelectedPanel = this.route.queryParams.subscribe(params => {
      if(params.selectedPanel){
        this.selectedPanel = params.selectedPanel;
      }else{
        this.selectedPanel = openOnDefault;
      }
      if(!environment.production) console.log("selectedPanel params", params);
      if(this.selectedPanel == "locationsMap"){
        this.setIsLocationSelected(true);
      }else if( this.selectedPanel == "routingMap"){
        this.setIsRoutesSelected(true);
      }else if(this.selectedPanel == "geofencesMap"){
        this.setIsGeofencesSelected(true);
      }else if(this.selectedPanel == "potentialZonesMap"){
        this.setIsPotentialZonesSelected(true);
      }else if(this.selectedPanel == "prospectsMap"){
        this.setIsProspectsSelected(true);
      }else if(this.selectedPanel == "frecuencyZonesMap"){
        this.setIsFrecuencyZonesSelected(true);
      }else if(this.selectedPanel == "territoriesMap"){
        this.setIsTerritoriesSelected(true);
      }
    });
  }

}
